import {remCalc} from '_themeUtils'

const banner = {
    Banner: {
        baseStyle: () => ({
            text: {
                textStyle: {base: 'paragraphSm', xl: 'paragraphMd'},
                fontWeight: {base: 300, xl: 200},
                letterSpacing: {base: remCalc(0.5), xl: remCalc(1.5)},
            },
            link: {
                pb: remCalc(3),
                borderBottom: 'solid',
                borderBottomWidth: remCalc(1),
                fontWeight: {base: 200, xl: 300},
                letterSpacing: remCalc(1.5),
                minH: 'fit-content',
                h: 'fit-content',
                display: 'inline-block',
                textStyle: {base: 'paragraphSm', xl: 'paragraphMd'},
                _hover: {
                    textDecoration: 'none',
                },
            },
        }),
    },
}

export default banner
